import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import SectionCard from '../../positionTemplate/components/SectionCard';
import SelectField from '../components/SelectField';
import { getSectionAnchorId, PAID_BREAK_OPTIONS, SECTION_IDS } from '../constants';

const PAID_BREAK_ID = 'position-template-paid-break';

const LegalInfoSection = ({ values, setField }) => {
  const title = LanguageConverterV2('positionTemplate.create.legalInfo.title');
  const paidBreakTitle = LanguageConverterV2('positionTemplate.create.legalInfo.paidBreak.title');
  const paidBreakDescription = LanguageConverterV2(
    'positionTemplate.create.legalInfo.paidBreak.description'
  );

  const legalInfo = values.legalInfo || {};

  return (
    <Box
      id={getSectionAnchorId(SECTION_IDS.LEGAL_INFO)}
      data-testid="legal-info-section"
      sx={{ scrollMarginTop: '16px' }}
    >
      <SectionCard
        header={
          <Typography sx={{ color: BLACK[100], fontFamily: PRIMARY_FONT[700], fontSize: '14px' }}>
            {title}
          </Typography>
        }
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'space-between',
            padding: '12px 0',
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ color: BLACK[100], fontFamily: PRIMARY_FONT[700], fontSize: '14px' }}>
              {paidBreakTitle}
            </Typography>
            <Typography
              sx={{
                color: BLACK[70],
                fontFamily: PRIMARY_FONT[400],
                fontSize: '12px',
                marginTop: '2px',
              }}
            >
              {paidBreakDescription}
            </Typography>
          </Box>
          <Box sx={{ width: '280px' }}>
            <SelectField
              id={PAID_BREAK_ID}
              value={legalInfo.paidBreakBehavior ?? ''}
              options={PAID_BREAK_OPTIONS}
              onChange={(paidBreakBehavior) =>
                setField('legalInfo', { ...legalInfo, paidBreakBehavior })
              }
              ariaLabel={paidBreakTitle}
              testId={PAID_BREAK_ID}
            />
          </Box>
        </Box>
      </SectionCard>
    </Box>
  );
};

LegalInfoSection.propTypes = {
  values: PropTypes.shape({
    legalInfo: PropTypes.shape({
      paidBreakBehavior: PropTypes.string,
    }),
  }).isRequired,
  setField: PropTypes.func.isRequired,
};

export default LegalInfoSection;
